import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sanitizeHtml from 'sanitize-html';
import MembQnaCtxtApi from "Apis/MembQnaCtxtApi";
import MembQnaRegApi from "Apis/MembQnaRegApi";
import QnaTmpltCtxtApi from "Apis/QnaTmpltCtxtApi";
import GameSvcCdAllLstApi from "Apis/GameSvcCdAllLstApi";
import MembQnaCtgrLstApi from "Apis/MembQnaCtgrLstApi";
import MembGameRelLstApi from "Apis/MembGameRelLstApi";
import "Assets/css/Cs.css";
import "Assets/css/Ctnt.css";
import { useLocation } from "react-router-dom";
import MgpStore from "Stores/Store";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import { Helmet } from "react-helmet-async";
import ApiError from "Utils/ApiError";
import useRecaptcha from 'Utils/useRecaptcha';
import ApiResultModal from "Components/ApiResultModal";

const QnaRegUi = ({gameSvcCd}:any) => {
    const {data: langData}:any = UseLangLstQuery();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getctntKindCd = query.get("ctntCtgrCd");
    let getQnaSno = query.get("qnaSno");


    const [gameSvcCdState,setGameSvcCdState] = useState("");
    const [qnaKindCdState,setQnaKindCdState] = useState("Q");
    const [qnaCtgrCdState,setQnaCtgrCdState] = useState("");
    const [qnaTitlState,setQnaTitlState] = useState("");
    const [qnaCtxtState,setQnaCtxtState] = useState("");
    const [imgFileState,setImgFileState] = useState<File>();
    const [membGameYrelLstState,setMembGameYrelLstState] = useState([]);
    const [qnaCtgrCdLstState,setqnaCtgrCdLstState]=useState([]);
    const [gameYrelLstSelectMenuStates, setGameYrelLstSelectMenuStates] = useState(false);
    const [selectedSvcNmState, setSelectedSvcNmState] = useState("");
    const [ctgrSelectMenuStates, setCtgrSelectMenuStates] = useState(false);
    const [selectedCtgrNmState, setSelectedCtgrNmState] = useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    // const 

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };


    if(getGameSvcCd !=null){
        gameSvcCd = getGameSvcCd;
    }
    const fileUploadFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const targetFile = e.target.files?.[0];
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (!targetFile) {
            setImgFileState(undefined);
            return;
        }
        if (targetFile.size > maxSize) {
            openResultModal(langData?.MYPAGE_QNA_ATCH_FL_LIMIT_MSG_00 || '파일 크기는 5MB 이하만 업로드 가능합니다.');
            // clear the file input
            e.currentTarget.value = '';
            setImgFileState(undefined);
            return;
        }
        setImgFileState(targetFile);
    }
    if(gameSvcCd ==null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    useEffect(()=>{
        MembGameRelLstApi().then((resp)=>{
            setMembGameYrelLstState(resp.yrelLst);
            
            // URL 파라미터에서 gameSvcCd 확인
            const urlGameSvcCd = gameSvcCd;
            
            if (urlGameSvcCd && resp.yrelLst) {
                // URL로 지정된 게임이 있는 경우 해당 게임 찾기
                const selectedGame = resp.yrelLst.find((game: any) => game.gameSvcCd === urlGameSvcCd);
                
                if (selectedGame) {
                    // URL로 지정된 게임이 존재하는 경우
                    setGameSvcCdState(selectedGame.gameSvcCd);
                    setSelectedSvcNmState(selectedGame.gameNm);
                    
                    // 해당 게임의 카테고리 목록 불러오기
                    MembQnaCtgrLstApi(selectedGame.gameSvcCd).then((resp)=>{
                        setqnaCtgrCdLstState(resp.apiBody.ctgrLst);
                    });
                } else {
                    // 지정된 게임이 없으면 첫 번째 게임 선택
                    const firstGame = resp.yrelLst[0];
                    if (firstGame) {
                        setGameSvcCdState(firstGame.gameSvcCd);
                        setSelectedSvcNmState(firstGame.gameNm);
                        MembQnaCtgrLstApi(firstGame.gameSvcCd).then((resp)=>{
                            setqnaCtgrCdLstState(resp.apiBody.ctgrLst);
                        });
                    }
                }
            } else {
                // URL 파라미터가 없으면 첫 번째 게임 선택
                const firstGame = resp.yrelLst[0];
                if (firstGame) {
                    setGameSvcCdState(firstGame.gameSvcCd);
                    setSelectedSvcNmState(firstGame.gameNm);
                    MembQnaCtgrLstApi(firstGame.gameSvcCd).then((resp)=>{
                        setqnaCtgrCdLstState(resp.apiBody.ctgrLst);
                    });
                } else {
                    //setSelectedSvcNmState("게임을 선택해주세요");
                    setSelectedSvcNmState(langData?.MYPAGE_QNA_GAME_SEL_MSG_00 || "");
                }
            }
        });
    },[MgpStore.getState().LangSetState.Lang, gameSvcCd]);
    const SelectSvcCdHandler = (e:any) => {
        setGameSvcCdState(e.currentTarget.value);
        MembQnaCtgrLstApi(e.currentTarget.value).then((resp)=>(
            setqnaCtgrCdLstState(resp.apiBody.ctgrLst)
        ))
    }
    
    const GameYrelLstSelectMenuToggle = () => {
        setGameYrelLstSelectMenuStates(gameYrelLstSelectMenuStates => !gameYrelLstSelectMenuStates);
    }
    
    function returnOfIndex(value:string, membGameYrelLstState:any){
        let index;
        for(var i=0; i<membGameYrelLstState.length; i++){
            if(membGameYrelLstState[i].gameNm.indexOf(value) != -1){
                index=i;
            }
        }
        return index;
    }
    
    const SelectValueSetFunc =(value:string) => {
        var returnValue = returnOfIndex(value,membGameYrelLstState)
        if(returnValue == undefined) {
            returnValue =0;
        }
        const selectedGame = membGameYrelLstState[returnValue] as any;
        setGameSvcCdState(selectedGame.gameSvcCd);
        setSelectedSvcNmState(selectedGame.gameNm);
        GameYrelLstSelectMenuToggle();
        
        // 카테고리 목록도 새로고침
        MembQnaCtgrLstApi(selectedGame.gameSvcCd).then((resp)=>(
            setqnaCtgrCdLstState(resp.apiBody.ctgrLst),
            //setSelectedCtgrNmState("카테고리를 선택해주세요") // 게임 변경 시 카테고리 초기화
            setSelectedCtgrNmState(langData?.MYPAGE_QNA_CTGR_SEL_MSG_00 || "") // 게임 변경 시 카테고리 초기화
        ))
    }
    
    const CtgrSelectMenuToggle = () => {
        setCtgrSelectMenuStates(ctgrSelectMenuStates => !ctgrSelectMenuStates);
    }
    
    function returnOfCtgrIndex(value:string, qnaCtgrCdLstState:any){
        let index;
        for(var i=0; i<qnaCtgrCdLstState.length; i++){
            if(qnaCtgrCdLstState[i].ctgrNm.indexOf(value) != -1){
                index=i;
            }
        }
        return index;
    }
    
    const SelectCtgrValueSetFunc =(value:string) => {
        var returnValue = returnOfCtgrIndex(value, qnaCtgrCdLstState)
        if(returnValue == undefined) {
            returnValue =0;
        }
        const selectedCtgr = qnaCtgrCdLstState[returnValue] as any;
        setQnaCtgrCdState(selectedCtgr.ctgrCd);
        setSelectedCtgrNmState(selectedCtgr.ctgrNm);
        CtgrSelectMenuToggle();
        
        // 템플릿 내용 불러오기
        QnaTmpltCtxtApi(gameSvcCdState, selectedCtgr.ctgrCd).then((resp)=>{
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = resp.apiBody.ctntCtxt;
            let textContent = tempDiv.textContent || tempDiv.innerText || "";
            textContent = textContent.replace(/\\n/g, '\n');
            setQnaCtxtState(textContent);
        })
    }
    const qnaTxtArea = document.getElementById("qnaTxtArea")
    const SelectCtgrCdHandler = (e:any) => {
        setQnaCtgrCdState(e.currentTarget.value);
        QnaTmpltCtxtApi(gameSvcCdState,e.currentTarget.value).then((resp)=>{
            // HTML 태그를 제거하고 \n을 실제 줄바꿈으로 변환
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = resp.apiBody.ctntCtxt;
            let textContent = tempDiv.textContent || tempDiv.innerText || "";
            // \n을 실제 줄바꿈으로 변환
            textContent = textContent.replace(/\\n/g, '\n');
            setQnaCtxtState(textContent);
        })
    }
    const TitlInputHandler = (e:any) => {
        setQnaTitlState(e.currentTarget.value);
    }
    const QnaCtxtInputHandler = (e:any) => {
        setQnaCtxtState(e.currentTarget.value);
    }
   const { getToken } = useRecaptcha();

   const MembQnaRegFunc = async (gameSvcCd:string,qnaSno:string,qnaKindCd:string,qnaCtgrCd:string,qnaTitl:string,qnaCtxt:string,imgFile:File|undefined) => {
        if(gameSvcCd == "" || gameSvcCd == "null") {
            openResultModal(`${langData&&langData.MYPAGE_QNA_INPUT_REG_FAIL_DESC_00}`);
            return;
        } 
        if(qnaCtgrCd == "" || qnaCtgrCd == "null") {
            openResultModal(`${langData&&langData.MYPAGE_QNA_INPUT_REG_FAIL_DESC_01}`);
            return;
        }   
        if(qnaTitl == "") {
            openResultModal(`${langData&&langData.MYPAGE_QNA_INPUT_REG_FAIL_DESC_02}`);
            return;
        }
        if(qnaCtxt == "") {
            openResultModal(`${langData&&langData.MYPAGE_QNA_INPUT_REG_FAIL_DESC_03}`);
            return;
        }

        try {
            // request reCAPTCHA token just before submit
            // eslint-disable-next-line no-console
            console.debug('MembQnaRegFunc requesting reCAPTCHA token');
            const token = await getToken('qna_reg');
            // eslint-disable-next-line no-console
            console.debug('MembQnaRegFunc token', { token: token ? '[RECEIVED]' : '[EMPTY]' });

            const resp:any = await MembQnaRegApi(gameSvcCd,qnaSno,qnaKindCd,qnaCtgrCd,qnaTitl,sanitizeHtml(qnaCtxt),imgFile, token);
            switch(resp.apiHdr.code) {
                case "ATHN2304":
                    //alert("reCAPTCHA 실행 실패. 잠시 후 다시 시도해주세요.");
                    openResultModal(`${langData&&langData.COMM_CPTCH_ERROR_DESC_00}`);
                    break;
                case "MEMB0000":
                    openResultModal(
                        `${langData&&langData.MYPAGE_QNA_MAIN_REG_SUCC_DESC_00}`,
                        () => {
                            window.location.href=`/MyPage/QnaLst`;
                        }
                    );
                    break;
                case "COMM3012":
                    openResultModal(`${langData&&langData.MYPAGE_QNA_MAIN_REG_FAIL_DESC_01}`);
                    break;
                case "COMM3009":
                    openResultModal(`${langData&&langData.MYPAGE_QNA_MAIN_REG_FAIL_DESC_02}`);
                    // 비허용 확장자
                break;
                case "COMM3010":
                    openResultModal(`${langData&&langData.MYPAGE_QNA_MAIN_REG_FAIL_DESC_03}`);
                    // 허용 파일 크기 초과
                break;
                default:
                    ApiError(langData, resp.apiHdr.code);
                break;
            }
        } catch (e:any) {
            // eslint-disable-next-line no-console
            console.error('MembQnaRegFunc error', e);
            openResultModal(langData && langData.COMM_MAIN_RSLT_DESC_00 || '오류가 발생했습니다.');
        }
    };
   
    return(
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_QNA_MAIN_REG_BTN_00}`}</title>
            </Helmet>
        <div className="container1300 BgW pb200">
                <div className="myPageSubTitlWrap">
                    <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_QNA_MAIN_REG_BTN_00}</p>
                </div>
                <div className="mypageSubCtgrMenuWrap">
                    <div className="qnaWrap">
                        <div className="qnaCtgrMenu" >
                            <p className="qnaLbl">{langData&&langData.MYPAGE_QNA_CTGR_LST_LBL_00}</p>
                            <div className="qnaCtgrSelectWrap">
                                <div 
                                    className="ctxtLiTitl relative"
                                    onBlur={() => setGameYrelLstSelectMenuStates(false)}
                                    tabIndex={0}
                                >
                                    <p className={gameYrelLstSelectMenuStates?'gameYrelSelectTitl active':"gameYrelSelectTitl"} onClick={() => GameYrelLstSelectMenuToggle()}> {selectedSvcNmState || langData?.MYPAGE_QNA_GAME_SEL_MSG_00 || ''} </p>
                                    <div className={gameYrelLstSelectMenuStates?'gameYrelWrap active':"gameYrelWrap"}>
                                        <ul >
                                            {
                                                membGameYrelLstState&&membGameYrelLstState.map((key:any) => (
                                                    <li key={key.gameSvcCd} onClick={()=>SelectValueSetFunc(key.gameNm)}>
                                                        {key.gameNm}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                                <div 
                                    className="ctxtLiTitl relative"
                                    onBlur={() => setCtgrSelectMenuStates(false)}
                                    tabIndex={0}
                                >
                                    <p className={ctgrSelectMenuStates?'gameYrelSelectTitl active':"gameYrelSelectTitl"} onClick={() => CtgrSelectMenuToggle()}> {selectedCtgrNmState || langData?.MYPAGE_QNA_CTGR_SEL_MSG_00 || ''} </p>
                                    <div className={ctgrSelectMenuStates?'gameYrelWrap active':"gameYrelWrap"}>
                                        <ul >
                                            {
                                                qnaCtgrCdLstState&&qnaCtgrCdLstState.map((key:any) => (
                                                    <li key={key.ctgrCd} onClick={()=>SelectCtgrValueSetFunc(key.ctgrNm)}>
                                                        {key.ctgrNm}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="qnaTitlWrap">
                            {/* <p className="qnaLbl mt10">{langData&&langData.MYPAGE_QNA_TITL_LBL_00}</p> */}
                            {/*<p className="qnaLbl">문제가 발생했나요? 저희에게 문의해 주세요!</p> */}
                            <p className="qnaLbl">{langData&&langData.MYPAGE_QNA_TITL_LBL_00}</p>
                            <input type="text" placeholder={langData&&langData.MYPAGE_QNA_TITL_INPUT_DESC_00}  onChange={TitlInputHandler}/>
                        </div>
                        
                        <div className="qnaTextareaWrap">
                            <textarea 
                                name="" 
                                id="qnaTxtArea" 
                                value={qnaCtxtState || ""} 
                                onChange={QnaCtxtInputHandler}
                            >
                            </textarea>
                        </div>
                        <div  className="qnaTitlWrap">
                            <p className="qnaLbl">{langData&&langData.MYPAGE_QNA_ATCH_FL_TITL_00}</p>
                            <input type="file" onChange={fileUploadFunc}/>
                            {/*<p className="uploadNoti">5MB 이하 이미지·문서 파일(jpg, jpeg, png, gif, bmp, txt, doc, webp)만 업로드할 수 있어요.</p>*/}
                            <p className="uploadNoti">{langData && langData.MYPAGE_QNA_ATCH_FL_NOTI_LBL_00}</p>
                        </div>
                        <div className="ctntBtnWrap qnaBtnWrap">
                            <Link to={`/MyPage/QnaLst`}>
                                <p>{langData&&langData.MYPAGE_QNA_CNCL_BTN_00}</p>
                            </Link>
                            <button onClick={()=>MembQnaRegFunc(gameSvcCdState,"0",qnaKindCdState,qnaCtgrCdState,qnaTitlState,qnaCtxtState,imgFileState)}>
                                <p>{langData&&langData.MYPAGE_QNA_STAR_RTNG_BTN_00}</p>
                            </button>
                        </div>
                    </div>
                </div>
        </div>
        </>

            
    )
}

export default QnaRegUi;
